import i18n from "i18next";

import type { Equipment } from "api/services/content/schemas/shared";

export function translateExerciseEquipment(equipment: Equipment): string {
  const keyMap: Record<Equipment, string> = {
    backpack: i18n.t("library.exercises.fields.equipment_options.backpack"),
    chair: i18n.t("library.exercises.fields.equipment_options.chair"),
    exercise_ball: i18n.t("library.exercises.fields.equipment_options.exercise_ball"),
    foamroller: i18n.t("library.exercises.fields.equipment_options.foamroller"),
    mobility_aid: i18n.t("library.exercises.fields.equipment_options.mobility_aid"),
    pool: i18n.t("library.exercises.fields.equipment_options.pool"),
    resistance_band: i18n.t("library.exercises.fields.equipment_options.resistance_band"),
    sling: i18n.t("library.exercises.fields.equipment_options.sling"),
    stair: i18n.t("library.exercises.fields.equipment_options.stair"),
    stick: i18n.t("library.exercises.fields.equipment_options.stick"),
    towel: i18n.t("library.exercises.fields.equipment_options.towel"),
    water_bottles: i18n.t("library.exercises.fields.equipment_options.water_bottles"),
    weight: i18n.t("library.exercises.fields.equipment_options.weight"),
  };

  return keyMap[equipment] || "";
}
